module.exports = __webpack_public_path__ + "img/payment.59eab8ac.svg";